import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { CreateRivenditoreModalComponent } from './create-rivenditore-modal';

export const CreateRivenditoreModalModule: string = ng
    .module('archiSmall.components.createRivenditoreModalModule', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('createRivenditoreModalComponent', CreateRivenditoreModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/components/create-rivenditore-modal/create-rivenditore-modal.module.ts